module.exports = __webpack_public_path__ + "static/media/f_hairstyle_wavy_long_front.6026bae3.png";